import { render, staticRenderFns } from "./indices.vue?vue&type=template&id=64d1c3ea&"
import script from "./indices.vue?vue&type=script&lang=js&"
export * from "./indices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports